export default __webpack_public_path__ + "static/media/assets.f8bbbd62.png";